<template>
  <div class="privacy-policy-only">

    <h4>適用範囲</h4>
    <p>本プライバシーポリシーは、バイク駐輪可能性判定 宿マップ(以下、当サイト)においてのみ適用されます。</p>

    <h4>免責事項</h4>
  <p>
  当サイトに掲載されている情報は、可能な限り正確な情報を掲載するよう努めていますが、
  正確性や安全性を保証するものではありません。
  </p>
  <p>
    当サイトは月に１回のみ、データ更新を行うため、常に最新のデータとは限りません。
    宿泊施設の駐車場の状況は変わる可能性があるため、実際の駐車状況と異なる場合があります。
  </p>
  <p>
    当サイトはAIが判定を行っていますが、AIの判定はあくまで参考情報であり、実際の駐車状況を保証するものではありません。
  </p>

  <p>
  当サイトの利用によって生じた損害等について、
  当サイトでは一切の責任を負いかねますのでご了承ください。
  </p>

    <h4>個人情報</h4>
    <p>「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名・生年月日・住所・電話番号・連絡先その他の記述等により特定の個人を識別できる情報及び容貌・指紋・声紋にかかるデータ及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。</p>

    <h4>個人情報を収集・利用する目的</h4>
    <p>当サイトでは、お問い合わせフォームからお客様のメールアドレスを収集する場合があります。</p>
    <p>収集したメールアドレスは以下の目的で利用します：</p>
    <ul>
      <li>お問い合わせへの回答・対応</li>
    </ul>
    <p>ご本人の同意なく、これらの目的以外で個人情報を利用することはありません。</p>

    <h4>個人情報の第三者提供</h4>
    <p>当サイトは次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。</p>
    <ul>
      <li>人の生命、身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき</li>
      <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって本人の同意を得ることが困難であるとき</li>
      <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
      <li>予め次の事項を告知あるいは公表し，かつ当サイトが個人情報保護委員会に届出をしたとき
        <ul>
          <li>利用目的に第三者への提供を含むこと</li>
          <li>第三者に提供されるデータの項目</li>
          <li>第三者への提供の手段または方法</li>
          <li>本人の求めに応じて個人情報の第三者への提供を停止すること</li>
          <li>本人の求めを受け付ける方法</li>
        </ul>
      </li>
    </ul>
    <p>前項の定めにかかわらず、次に掲げる場合には当該情報の提供先は第三者に該当しないものとします。</p>
    <ul>
      <li>当サイトが利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合</li>
      <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
      <li>個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いた場合</li>
    </ul>

    <h4>個人情報の開示、訂正、追加、削除、利用停止</h4>
    <p>ご本人からの個人情報の開示、訂正、追加、削除、利用停止のご希望の場合には、ご本人であることを確認させて頂いた上、速やかに対応させていただきます。</p>

    <h4>Cookie（クッキー）</h4>
    <p>当サイトでは、アクセス解析サービス、各種アフィリエイトプログラム、広告配信サービスを利用しております。これらの広告配信業者は、ユーザーのご興味に応じた商品やサービスの広告を表示するため、ユーザーの当サイトおよび他サイトへのアクセスに関する情報Cookieを使用することがございます。</p>
    <p>Cookieによる情報収集を好まれない場合、ユーザーご自身でブラウザで受け入れを拒否するよう設定することも可能です。ただし、この設定により一部のコンテンツが正しく機能しない場合、またサービスが受けられない場合がございます。あらかじめご了承ください。</p>
    <p>なお、設定方法に関してはGoogleポリシーと規約にてご確認いただけます。</p>

    <h4>アクセス解析ツール</h4>
    <p>当サイトでは、Googleの提供するアクセス解析ツール『Google Analytics』を使用しています。Google Analyticsはトラフィックデータの収集のためCookieを利用します。このトラフィックデータは匿名で収集されており、個人を特定するものではございません。</p>
    <p>ユーザーは、Cookieを無効化することにより、データの収集を拒否することができます。お使いのブラウザより設定をご確認ください。</p>
    <p>なお、この規約に関しては、Google アナリティクス利用規約およびGoogleポリシーと規約でご確認いただけます。</p>

    <h4>広告ポリシー</h4>
    <p>当サイトは、以下の第三者の配信する広告サービスならびにアフィリエイトプログラムを利用し、アクセス情報を外部事業者に送信しております。</p>
    <p>当該の情報は個人を特定する情報ではございません。また当該の情報が目的外利用される事は一切御座いません。</p>
    <p><strong>送信される情報の内容</strong></p>
    <ul>
      <li>成果報酬型広告の表示日時</li>
      <li>成果報酬型広告のクリック日時</li>
      <li>成果報酬型広告の計測に必要なクッキー情報</li>
      <li>成果報酬型広告表示時及び広告クリック時のIPアドレス</li>
      <li>成果報酬型広告表示時及び広告クリック時に使用されたインターネット端末およびインターネットブラウザ－の種類</li>
    </ul>
    <p><strong>送信先となる事業者の氏名又は名称</strong></p>
    <ul>
      <li>Googleアドセンス（Google合同会社）</li>
    </ul>

    <h4>Googleアドセンスについて</h4>
    <p>当サイトは、第三者配信の広告サービス「Google Adsense（グーグルアドセンス）」を利用しています。当サイトにおいて広告が配信される過程で、Cookieやデバイス特有の情報、位置情報、当該デバイスから収集されるその他の情報が利用される場合があります。ただしその過程で個人を特定できる情報は収集されません。</p>
    <p>また、Google AdSenseに関して、このプロセスの詳細や情報が広告配信事業者に使用されないよう、ユーザーご自身で設定することができます。ただし、この設定により一部のコンテンツが正しく機能しない場合、またサービスが受けられない場合がございます。あらかじめご了承ください。</p>
    <p>なお、この設定方法に関してはGoogleポリシーと規約にてご確認いただけます。</p>

    <h4>アフィリエイトプログラムについて</h4>
    <p>当サイトは、楽天グループ株式会社を宣伝しリンクすることによってサイトが紹介料を獲得できるアフィリエイトプログラム「楽天アフィリエイト」に参加しています。</p>
    <p>商品・サービスのリンク先は当サイトではなく、楽天トラベル等の販売元サイトとなります。購入方法やサービス内容についてはリンク先のサイトをご確認ください。</p>

    <h4>利用目的</h4>
    <p>利用目的としては各ASPへの成果の効果を測定および不正防止のために利用しております。</p>
    <p>これらのサービスにおいて取得・収集される情報については、各プログラムのプライバシーポリシーにてご確認ください。</p>

    <h4>違法行為について</h4>
    <p>当サイトに掲載しているコンテンツについて、法的に許容されている範囲を超えて利用すること、また管理人の許可なく複製することを禁止いたします。</p>
    <p>当該行為が発覚した場合、適正と考えられる使用料あるいは損害賠償を請求いたします。その際、妥当な範囲での慰謝料を加える場合がございますことをあらかじめ申し添えておきます。</p>

    <h4>お問い合わせ</h4>
    <p>プライバシーポリシーに関するご質問やご意見がございましたら、以下よりお問い合わせください。</p>
    <p>
      <router-link to="/contact" class="contact-link">
        お問い合わせフォーム
      </router-link>
    </p>

    <p class="last-updated">最終更新日：2026年3月27日</p>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PrivacyPolicyOnly'
});
</script>

<style scoped>
.privacy-policy-only {
  line-height: 1.6;
}

.privacy-policy-only h3 {
  color: #2d3748;
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: bold;
}

.privacy-policy-only h4 {
  color: #4a5568;
  margin: 20px 0 10px 0;
  font-size: 14px;
  font-weight: bold;
}

.privacy-policy-only p {
  color: #4a5568;
  margin: 0 0 12px 0;
  font-size: 13px;
}

.privacy-policy-only ul {
  margin: 8px 0 16px 20px;
  padding: 0;
}

.privacy-policy-only li {
  color: #4a5568;
  margin: 4px 0;
  font-size: 13px;
}

.last-updated {
  margin-top: 24px !important;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
  font-style: italic;
  color: #718096 !important;
  text-align: right;
}

.contact-link {
  color: #4299e1;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s;
}

.contact-link:hover {
  color: #3182ce;
}

/* スマホ対応 */
@media (max-width: 768px) {
  .privacy-policy-only h3 {
    font-size: 15px;
    margin-bottom: 12px;
  }
  
  .privacy-policy-only h4 {
    font-size: 13px;
    margin: 16px 0 8px 0;
  }
  
  .privacy-policy-only p,
  .privacy-policy-only li {
    font-size: 12px;
  }
}
</style>
